export const POS_NOTIFICATION_REDIRECTION_MESSAGE = 'POS.NOTIFICATION.REDIRECT';
export const POS_COOKIE_SETTINGS = 'pos-cookie-settings';
export const COOKIE_ACCEPT = 'accept';
export const COOKIE_DECLINE = 'decline';
export const GTM_PAGE_VIEW_EVENT = 'pageview';
export const GTM_DATA_LAYER_NAME = 'dataLayer';
export const CLIENT_QUERY_PARAM = 'client';
export const REGION_QUERY_PARAM = 'region';
export const COUNTRY_QUERY_PARAM = 'country';
export const CATEGORY_QUERY_PARAM = 'brandcategory';
export const BRAND_QUERY_PARAM = 'brand';
export const PRODUCT_QUERY_PARAM = 'product';
export const POS_NOTIFICATION = 'P-OS-Notification';
export const DEFAULT_LOGO = 'webframe/logo-Primary-Dark-bg.svg';
export const GTM_PAGE_VIEW = 'pageview';
export const MODULE_NAME = 'Webframe';
export const LOGIN_CALLBACK_ROUTE_KEY = 'login_callback_route-key';
export const SHOW_INIT_DASHBOARD_FILTERS_KEY = 'show-init-dashboard-filters';

export const MODULE_PERMISSIONS: { [key: string]: string } = {
  'Cockpit.Home': 'Cockpit',
  'Webframe.Header.MakeItRight.Brief': 'Briefing',
  'Webframe.Header.MakeItRight.PathToGrowth': 'PathToGrowth',
  'Webframe.Header.MakeItRight.Audience': 'Audience',
  'Webframe.Header.MakeItMagic.Inspire': 'Inspire',
  'Webframe.Header.MakeItMagic.Design': 'Planning',
  'Webframe.Header.MakeItWork.Activate': 'Activation',
  'Webframe.Header.MakeItWork.OptimizeAndReport': 'OptimizeAndReport',
  Config: 'Config',
  CampaignMonitor: 'CampaignMonitor',
};
